module.exports = __webpack_public_path__ + "static/images/gift-enter02.e325ede.png";